import { createFileRoute } from '@tanstack/react-router';

import { BulkUploadParents } from '~pages/parents/bulk-upload';

export const Route = createFileRoute('/_auth/_layout/parents/bulk-upload/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <BulkUploadParents />;
}
